import { GlobalOutlined } from '@ant-design/icons'
import { CSSProperties, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonVariant, MyButton } from '../Button/Button'
import cls from './LangSwitcher.module.scss'

interface Props {
    variant?: ButtonVariant
    style?: CSSProperties
}
export const LangSwitcher = memo(({ variant = 'clear', style }: Props) => {
    const { t, i18n } = useTranslation()

    const toggle = () => {
        const newLanguage = i18n.language === 'ru' ? 'en' : 'ru'
        i18n.changeLanguage(newLanguage)
    }

    return (
        <MyButton
            variant={variant}
            onClick={toggle}
            color="normal"
            aria-label={t('Язык')}
            style={{
                minHeight: 44,
                minWidth: 44,
                padding: '8px 14px',
                boxSizing: 'border-box',
                ...style
            }}
        >
            <GlobalOutlined className={cls.icon} />
            {t('Язык')}
        </MyButton>
    )
})
